import moment from 'moment';

export const eighteenYearsEarlier = () => moment.utc().subtract(18, 'years').toDate();

export const socialSecurityNumberRegexp = /^(?!000|666|9\d{2})\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/;
